import { Cuboid } from "./Cuboid";

export const PrimitiveWithAxisCross = {
    ...Cuboid,
    axisCross: 1000,
};
